if (!customElements.get('wlsn-reworked-product')) {
  class WlsnReworkedProduct extends HTMLElement {
    constructor() {
      super();
      /**
       * CSS class names used in this component
       */
      this.classes = {
        active: 'active',
        trigger: 'js-wlsn-reworked-product-trigger',
        cta: 'js-wlsn-product-cta',
        price: 'js-wlsn-product-price',
        priceStrikethrough: 'js-wlsn-product-price-strikethrough',
        priceStrikethroughWithoutBundle: 'js-wlsn-product-price-strikethrough-without-bundle',
        label: 'js-wlsn-product-label',
      };
      /**
       * Cached DOM elements
       */
      this.elements = {
        trigger: this.querySelectorAll(`.${this.classes.trigger}`),
        cta: this.querySelectorAll(`.${this.classes.cta}`),
      };
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
    }

    /**
     * Called when the element is inserted into the DOM
     */
    connectedCallback() {
      // Only set up listeners if there are triggers
      if (!this.elements.trigger || this.elements.trigger.length === 0) return;
      this.elements.trigger.forEach(trigger => {
        trigger.addEventListener('click', this.handleTriggerClick);
      });
    }

    /**
     * Called when the element is removed from the DOM
     */
    disconnectedCallback() {
      // Only remove listeners if there are triggers
      if (!this.elements.trigger || this.elements.trigger.length === 0) return;
      this.elements.trigger.forEach(trigger => {
        trigger.removeEventListener('click', this.handleTriggerClick);
      });
    }

    /**
     * Handle click on the reworked product trigger
     * @param {MouseEvent} e
     */
    handleTriggerClick(e) {
      const trigger = e.currentTarget;
      const id = trigger.getAttribute('data-reworked-product-id-trigger');
      if (!id) return;

      const updateMultipleProducts = trigger.hasAttribute('data-reworked-product-update-multiple-products');
      const isActive = trigger.classList.contains(this.classes.active);

      if (updateMultipleProducts) {
        // Update all triggers to match the clicked state
        this.elements.trigger.forEach(otherTrigger => {
          if (!isActive) {
            otherTrigger.classList.add(this.classes.active);
          } else {
            otherTrigger.classList.remove(this.classes.active);
          }
          
          // Get and update data for each trigger
          const triggerId = otherTrigger.getAttribute('data-reworked-product-id-trigger');
          if (triggerId) {
            const dataScript = this.querySelector(`script[data-reworked-product-id-data="${triggerId}"]`);
            if (dataScript) {
              try {
                const data = JSON.parse(dataScript.textContent);
                const newData = !isActive ? data.reworked : data.regular;
                
                // Always update prices for all products
                this.updateProductPrices(newData, triggerId);
                
                // Only update button URLs if this element has active class
                const element = this.querySelector(`[data-reworked-product-id-data-update="${triggerId}"]`);
                if (element && element.classList.contains(this.classes.active)) {
                  console.log('element', element);
                  this.updateButtonUrls(newData, triggerId);
                }
              } catch (err) {
                console.error('Error parsing JSON Reworked Product data', err);
              }
            }
          }
        });
      } else {
        // Single trigger update
        const dataScript = this.querySelector(`script[data-reworked-product-id-data="${id}"]`);
        if (!dataScript) return;
        let data;
        try {
          data = JSON.parse(dataScript.textContent);
        } catch (err) {
          console.error('Error parsing JSON Reworked Product data', err);
          return;
        }
        if (!isActive) {
          trigger.classList.add(this.classes.active);
          this.updateProductPrices(data.reworked, id);
          this.updateButtonUrls(data.reworked, id);
        } else {
          trigger.classList.remove(this.classes.active);
          this.updateProductPrices(data.regular, id);
          this.updateButtonUrls(data.regular, id);
        }
      }
    }

    /**
     * Update product prices (price and strikethrough price)
     * @param {Object} data
     * @param {string} id
     */
    updateProductPrices(data, id) {
      if (!data) return;

      // Find all elements with matching data-reworked-product-id-data-update
      const elements = this.querySelectorAll(`[data-reworked-product-id-data-update="${id}"]`);
      
      elements.forEach(element => {
        const label = element.querySelectorAll(`.${this.classes.label}`);
        const priceStrikethrough = element.querySelectorAll(`.${this.classes.priceStrikethrough}`);
        const priceStrikethroughWithoutBundle = element.querySelectorAll(`.${this.classes.priceStrikethroughWithoutBundle}`);
        const price = element.querySelectorAll(`.${this.classes.price}`);

        if (priceStrikethrough?.length) {
          priceStrikethrough.forEach(el => {
            if (data.priceStrikethrough !== undefined) el.textContent = data.priceStrikethrough;
          });
        }
        if (priceStrikethroughWithoutBundle?.length) {
          priceStrikethroughWithoutBundle.forEach(el => {
            if (data.priceStrikethroughWithoutBundle !== undefined) el.textContent = data.priceStrikethroughWithoutBundle;
          });
        }

        if (price?.length) {
          price.forEach(el => {
            if (data.price !== undefined) el.textContent = data.price;
          });
        }
        if (label?.length) {
          label.forEach(el => {
            if (data.label !== undefined) el.textContent = data.label;
            if (data.labelColor !== undefined) el.style.color = data.labelColor;
            if (data.labelBackgroundColor !== undefined) el.style.background = data.labelBackgroundColor;
          });
        }
      });
    }

    /**
     * Update button URLs for a specific product
     * @param {Object} data
     * @param {string} id
     */
    updateButtonUrls(data, id) {
      if (!data || !data.checkoutLink || !this.elements.cta?.length) return;

      this.elements.cta.forEach(el => {
        if (data.checkoutLink) el.setAttribute('href', data.checkoutLink);
      });
    }
  }
  customElements.define('wlsn-reworked-product', WlsnReworkedProduct);
}